<template>
  <v-form>
    <v-card class="form-card" id="poll-data-pageType">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>
              Selecione o tipo de página que deseja criar
              <b class="requiredfield">*</b>
            </h3>

            <v-sheet class="red--text" v-if="requiredErrorType">
              {{ requiredErrorTypeText }}
            </v-sheet>
          </v-col>

          <v-col cols="8" class="nonothing">
            <v-radio-group v-model="pageType" :mandatory="false">
              <div class="d-inline-flex">
                <v-radio label value="VOTING_SHOWCASE"></v-radio>
                <div>
                  <p class="text-subtitle-2 mb-0">Vitrine de Projetos</p>
                  <p class="grey--text text-body-2">
                    Disponibilize os projetos publicamente na plataforma para que possam ser visualizados por qualquer usuário na web.
                  </p>
                </div>
              </div>

              <div class="d-inline-flex">
                <v-radio label value="VOTING_PORTAL"></v-radio>
                <div>
                  <p class="text-subtitle-2 mb-0">Portal de Votação</p>
                  <p class="grey--text text-body-2">
                    Selecione os projetos que participarão do processo de votação online e deixe que o público escolha quem receberá o apoio ou seguirá para a próxima etapa do edital
                  </p>
                </div>
              </div>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="form-card" id="poll-data-name">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>
              Nome
              <b class="requiredfield">*</b>
            </h3>

            <v-sheet class="red--text" v-if="requiredErrorName">
              {{ requiredErrorNameText }}
            </v-sheet>
          </v-col>

          <v-col cols="8">
            <v-text-field v-model="name" :counter="255" label="Insira o título do seu whitelabel" required>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card>


    <v-card class="form-card" id="poll-data-description">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="12">
            <h3>
              Descrição
              <b class="requiredfield">*</b>
            </h3>

            <v-sheet class="red--text" v-if="requiredErrorDescription">
              {{ requiredErrorDescriptionText }}
            </v-sheet>

            <vue-editor v-model="description"
              :editor-toolbar="customToobarDescription" required></vue-editor>
            <v-sheet class="d-flex justify-end">
              <v-sheet :class="[descriptionLength >= 8000 ? 'red--text' : '']" >
                {{ descriptionLength }}
              </v-sheet> / 8000
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="form-card" id="poll-data-photos">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="12">
            <h3>
              Insira abaixo a imagem de perfil e o slider principal do whitelabel que será mostrado em sua página:
              <b class="requiredfield">*</b>
              <FormInstruction filedId="poll-data-photos" />
            </h3>

            <v-sheet class="red--text" v-if="requiredErrorImages">
              {{ requiredErrorImagesText }}
            </v-sheet>

            <v-container class="nopadding">
              <v-row>
                <v-col cols="3">
                  <ImageCropper type="logo" :imageData="visualIdentity" @setImageEvent="setImageLogoEvent" title="Inserir Imagem da Logo" />
                </v-col>

                <v-col cols="9">
                  <ImageCropperLandscape type="front" :imageData="slider" @setImageEvent="setImageFrontEvent" title="Inserir Imagem de Capa" />
                </v-col>
              </v-row>
            </v-container>
            </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-form>
</template>

<style>

.cropper {
  height: 200px;
  background: #DDD;
}

</style>


<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { VueEditor } from "vue2-editor";
import ImageCropper from '@/components/form/formField/ImageCropper';
import ImageCropperLandscape from '@/components/form/formField/ImageCropperLandscape';
import FormFieldHelper from '@/components/form/formField/helper/FormFieldHelper';
import { Cropper } from 'vue-advanced-cropper'

export default {
  name: "FormPollData",
  components: {
    VueEditor,
    ImageCropper,
    ImageCropperLandscape,
    FormInstruction: FormFieldHelper,
    Cropper
  },
  props: [
    'poll'
  ],
  watch: {
    pageType() {
      this.$emit( "getParams", this.pageType )
    }
  },
  data: () => ({
    img: 'https://images.pexels.com/photos/226746/pexels-photo-226746.jpeg',
    itemsWithErrors: {
      pageType: false,
      name: false,
      description: false,
      images: false
    },
    hasErrors: false,
    requiredErrorType: false,
    requiredErrorName: false,
    requiredErrorDescription: false,
    requiredErrorImages: false,
    requiredErrorTypeText: null,
    requiredErrorNameText: '',
    requiredErrorDescriptionText: '',
    requiredErrorImagesText: null,
    customToobarDescription: [
      [{
        size: [ "small", false, "large", "huge" ]
      }],
      [ "bold", "italic", "underline" ],
      [{
        list: "ordered"
      }, {
        list: "bullet"
      }],
      [{
        align: ""
      }, {
        align: "center"
      }, {
        align: "right"
      }, {
        align: "justify"
      }],
      [
        "link"
      ],
    ],
  }),
  computed: {
    pageType: {
      get() { return this.poll.data.pageType },
      set(value) { this.$store.commit('updatePageType', value) }
    },
    name: {
      get() { return this.poll.data.name },
      set(value) { this.$store.commit('updateName', value) }
    },
    description: {
      get() { return this.poll.data.description },
      set(value) { this.$store.commit('updateDescription', value) }
    },
    visualIdentity: {
      get() { return this.poll.data.photos ? this.poll.data.photos.visualIdentity : '' },
      set(value) { this.$store.commit('updateVisualIdentity', value) }
    },
    slider: {
      get() { return this.poll.data.photos ? this.poll.data.photos.slider : '' },
      set(value) { this.$store.commit('updateSlider', value) }
    },
    descriptionLength: function (){
      if( !this.description || this.description.length === 0 )
        return 0

      let totalCharacters = this.description.replace(
        /<\/?[^>]+(>|$)/g,
        ""
      ).length;
      return totalCharacters;
    }
  },
  methods: {
    isFormValid() {
      this.hasErrors = false;
      this.validateFormData()
      this.hasErrors = !Object.values(this.itemsWithErrors).filter(error => error).length > 0;
      return this.hasErrors;
    },
    validateFormData() {
      this.requiredPageType()
      this.requiredName()
      this.requiredDescription()
      this.requiredImages()
    },
    requiredPageType() {
      if (!this.pageType) {
        this.requiredErrorType = true
        this.itemsWithErrors.pageType = true;
        this.requiredErrorTypeText = "O campo tipo de página é obrigatório!"
      } else {
        this.requiredErrorType = false;
        this.itemsWithErrors.pageType = false;
      }
    },
    requiredName() {
      if (!this.name) {
        this.requiredErrorName = true
        this.itemsWithErrors.name = true;
        this.requiredErrorNameText = "O campo nome é obrigatório!"
      } else {
        this.requiredErrorName = false
        this.itemsWithErrors.name = false;
      }
    },
    requiredDescription() {
      if (!this.description) {
        this.requiredErrorDescription = true
        this.itemsWithErrors.description = true;
        this.requiredErrorDescriptionText = "O campo descrição é obrigatório!"
      } else {
        this.requiredErrorDescription = false
        this.itemsWithErrors.description = false;
      }
    },
    requiredImages() {
      if (!this.poll.data || !this.poll.data.photos ||
        !this.poll.data.photos.visualIdentity || !this.poll.data.photos.slider) {
        this.requiredErrorImages = true
        this.itemsWithErrors.images = true;
        this.requiredErrorImagesText = "As imagens são obrigatórias!"
        return;
      }
      this.requiredErrorImages = false
      this.itemsWithErrors.images = false;
    },
    setImageLogoEvent(payload) {
      this.visualIdentity = payload;
    },
    setImageFrontEvent(payload) {
      this.slider = payload;
    },
  }
};
</script>

<style lang="scss" scoped>
.nonothing {
  margin: 0 !important;
  padding: 0 !important;
}

.nopadding {
  padding: 0 !important;
}

// FORMSPAGE
#poll-data-pageType, #poll-data-name, #poll-data-description, #poll-data-photos {
  background: #fcfcfc !important;
  border: thin solid #d3d3d3;
  border-left: 3px solid #2d9fab;
  box-shadow: none !important;
  margin: 0 0 24px !important;
  padding: 8px !important;
  display: grid;
  border-radius: 0 !important;

  h3 {
    color: #242424;
    font-family: 'Source Sans Pro', sans-serif;
    margin: 0 0 10px;
    font-size: 18px;
    line-height: 22px;
    font-weight: normal;
    opacity: 0.9;

    .requiredfield {
      color: #2e9fac;
      font-size: 22px;
      line-height: 14px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/poll/FormPollData.vue